// React
import { useState } from "react"

export function useSelectValue(): {
  value: string
  onChange: (value: string) => void
} {
  // Hooks
  const [value, setValue] = useState<string>("")

  return { value, onChange: setValue }
}